
import { ZfastSectionsAsIs } from '../../shared/components/ZfastSectionsAsIs';
import { PageShell } from '../PageShell/index';

export function Products() {
  return (
    <PageShell title="Products" eyebrow="Catalogue" path="/products" description="Explore product information for animal feed and edible oils, with enquiry support for farmers, dealers, distributors, retailers, and bulk buyers." hideHeader>
      <ZfastSectionsAsIs />

    </PageShell>
  );
}
